import { render, staticRenderFns } from "./DeliveryTracking.vue?vue&type=template&id=74a5b4f9&scoped=true"
import script from "./DeliveryTracking.vue?vue&type=script&lang=js"
export * from "./DeliveryTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a5b4f9",
  null
  
)

export default component.exports